import {Component} from 'react';
import PropTypes from 'prop-types';
import {Form, Grid, Segment} from 'semantic-ui-react';
import SoiIndicativePriceTip from './SoiIndicativePriceTip';
import DollarInputFormField from './DollarInputFormField';
import NumberValidator from '../lib/NumberValidator';
import {clearIndicativeSellingPriceErrors, updateIndicativeSellingPrice} from '../ducks/indicativeSellingPrice';

export default class IndicativeSellingPrice extends Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    indicativeSellingPrice: PropTypes.shape({
      errors: PropTypes.object.isRequired,
      sellingPriceType: PropTypes.string,
      singlePrice: PropTypes.number,
      priceRange: PropTypes.shape({
        max: PropTypes.number,
        min: PropTypes.number,
      }),
    }).isRequired,
    propertyDetail: PropTypes.object.isRequired,
  };

  onChange = () => {
    const {dispatch} = this.props;
    dispatch(clearIndicativeSellingPriceErrors());
  };

  onSellingPriceTypeChange = (e, target) => {
    const {dispatch} = this.props;
    const sellingPriceType = target.value;
    dispatch(updateIndicativeSellingPrice({
      sellingPriceType,
    }, true));
    this.onChange();
  };

  onSinglePriceChange = (e, target) => {
    if (NumberValidator.isValidInteger(target.value, 8)) {
      const {dispatch} = this.props;
      const singlePrice = parseInt(target.value, 10);
      dispatch(updateIndicativeSellingPrice({
        singlePrice,
      }, true));
      this.onChange();
    }
  };

  onPriceChange = (type, e, target) => {
    if (NumberValidator.isValidInteger(target.value, 8)) {
      const {dispatch} = this.props;
      const priceRange = {};
      priceRange[type] = parseInt(target.value, 10);
      dispatch(updateIndicativeSellingPrice({
        priceRange,
      }, true));
      this.onChange();
    }
  };

  render() {
    const {
      indicativeSellingPrice: {sellingPriceType, singlePrice, priceRange: {min, max}, errors}
    } = this.props;
    return (
      <Segment basic>
        <Grid centered>
            <Grid.Row style={{paddingBottom: '0'}}>
              <Grid.Column width={16} style={{ padding: '0' }}>
                <Form className="selling-price">
                  <h3>
                    Indicative Selling Price <SoiIndicativePriceTip/>
                  </h3>
                  <Form.Group>
                    <Form.Radio className="single-price-choice"
                                width={5}
                                style={{paddingTop: '0.5em'}}
                                name="sellingPriceType"
                                onChange={this.onSellingPriceTypeChange}
                                checked={sellingPriceType === 'single-price'}
                                label="Single Price"
                                value="single-price"/>
                    <DollarInputFormField
                      className={`single-price${sellingPriceType !== 'single-price' ? ' hidden' : ''}`}
                      error={errors.singlePrice}
                      inputValue={singlePrice}
                      placeholder="amount"
                      onChange={this.onSinglePriceChange}/>
                  </Form.Group>
                  <Form.Group style={{marginTop: '0', marginBottom: '0'}}>
                    <Form.Radio className="price-range-choice"
                                width={5}
                                style={{paddingTop: '0.5em'}}
                                name="sellingPriceType"
                                checked={sellingPriceType === 'price-range'}
                                onChange={this.onSellingPriceTypeChange}
                                label="Price Range"
                                value="price-range"/>
                    <DollarInputFormField
                      className={`price-range-min${sellingPriceType !== 'price-range' ? ' hidden' : ''}`}
                      error={errors.min}
                      inputValue={min}
                      placeholder="min"
                      name="min"
                      onChange={this.onPriceChange.bind(this, 'min')}/>
                    <DollarInputFormField
                      className={`price-range-max${sellingPriceType !== 'price-range' ? ' hidden' : ''}`}
                      error={errors.max}
                      inputValue={max}
                      placeholder="max"
                      name="max"
                      onChange={this.onPriceChange.bind(this, 'max')}/>
                  </Form.Group>
                </Form>
              </Grid.Column>
            </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}
